import { type Customer } from '@hungryroot/customer';
import { FoodProfileDisclosure } from '@hungryroot/page-food-profile';
import { useTagGroup } from '@hungryroot/rest-hooks';
import { FOOD_PROFILE_NEVERS_DEEP_LINK } from '@hungryroot/routes';
import { tagGroups, useCustomerTagGroup } from '@hungryroot/tags';
import { Paragraph, Heading, Dislike } from '@hungryroot/ui-kit';
import { getCustomerTags } from '../../utils/getCustomerTags';
import {
  ControlTagSwitch,
  DislikeTagPreference,
  Variant as ControlTagSwitchVariant,
} from '../ControlTagSwitch/ControlTagSwitch';
import styles from './IngredientsSection.module.css';

interface Props {
  testid?: string;
  customerId: Customer['id'];
}

export function IngredientsSection(props: Props) {
  const { testid, customerId } = props;

  const { data: customerTagGroupData } = useCustomerTagGroup(
    tagGroups.polarizing2
  );

  // Fetches tags from API so we can compare them to the customer's preferences when rendering `subtitle`
  const tagGroup = useTagGroup(tagGroups.polarizing2);
  const { data: tagGroupData } = tagGroup || {};
  const queryTags = tagGroupData?.tags;

  const subtitle = getCustomerTags(
    customerTagGroupData,
    queryTags,
    DislikeTagPreference.Selected
  );

  return (
    <section data-testid={testid} className={styles.container}>
      <FoodProfileDisclosure
        testid={`${testid}-disclosure`}
        title="Dislikes"
        subtitle={subtitle || 'Set your preferences.'}
        icon={<Dislike />}
        deepLink={FOOD_PROFILE_NEVERS_DEEP_LINK}
        scrollOnDeepLink={false}
      >
        <Heading className={styles.title} variant="H5">
          Anything you don't care for?
        </Heading>
        <Paragraph className={styles.text}>
          Your selections guide our suggestions, so you'll rarely see items with
          those flavors
        </Paragraph>
        <ControlTagSwitch
          testid={`${testid}-control`}
          customerId={customerId}
          colCount={2}
          tagGroupId={tagGroups.polarizing2}
          variant={ControlTagSwitchVariant.Dislike}
        />
      </FoodProfileDisclosure>
    </section>
  );
}
